export default {
	"type": "form",
	"tags": [],
	"owner": "5b880606acd5b553f1ad58ea",
	"components": [
	  {
		"clearOnHide": false,
		"key": "panel3",
		"input": false,
		"title": "",
		"theme": "default",
		"tableView": false,
		"components": [
		  {
			"clearOnHide": false,
			"label": "Columns",
			"input": false,
			"tableView": false,
			"key": "panel3Columns",
			"columns": [
			  {
				"components": [
				  {
					"clearOnHide": false,
					"key": "panel3ColumnsPanel",
					"input": false,
					"title": "Vendor Information",
					"theme": "default",
					"tableView": false,
					"components": [
					  {
						"autofocus": false,
						"input": true,
						"tableView": true,
						"inputType": "text",
						"inputMask": "",
						"label": "Vendor Name",
						"key": "vendorName",
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"defaultValue": "",
						"protected": false,
						"unique": false,
						"persistent": true,
						"hidden": false,
						"clearOnHide": true,
						"spellcheck": true,
						"validate": {
						  "required": false,
						  "minLength": "",
						  "maxLength": "",
						  "pattern": "",
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"type": "textfield",
						"labelPosition": "top",
						"inputFormat": "plain",
						"tags": [],
						"properties": {},
						"lockKey": true,
						"isNew": false,
						"customClass": "",
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"dataGridLabel": false,
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"hideLabel": false,
						"tabindex": "",
						"disabled": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": {
						  "type": "input"
						},
						"attributes": {},
						"validateOn": "change",
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"mask": false,
						"id": "e019h28"
					  },
					  {
						"autofocus": false,
						"input": true,
						"tableView": true,
						"inputType": "text",
						"inputMask": "",
						"label": "Address",
						"key": "address",
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"defaultValue": "",
						"protected": false,
						"unique": false,
						"persistent": true,
						"hidden": false,
						"clearOnHide": true,
						"spellcheck": true,
						"validate": {
						  "required": false,
						  "minLength": "",
						  "maxLength": "",
						  "pattern": "",
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"type": "textfield",
						"labelPosition": "top",
						"inputFormat": "plain",
						"tags": [],
						"properties": {},
						"customClass": "",
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"dataGridLabel": false,
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"hideLabel": false,
						"tabindex": "",
						"disabled": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": {
						  "type": "input"
						},
						"attributes": {},
						"validateOn": "change",
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"mask": false,
						"id": "ek2ixme"
					  },
					  {
						"autofocus": false,
						"input": true,
						"tableView": true,
						"inputType": "text",
						"inputMask": "",
						"label": "City",
						"key": "city",
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"defaultValue": "",
						"protected": false,
						"unique": false,
						"persistent": true,
						"hidden": false,
						"clearOnHide": true,
						"spellcheck": true,
						"validate": {
						  "required": false,
						  "minLength": "",
						  "maxLength": "",
						  "pattern": "",
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"type": "textfield",
						"labelPosition": "top",
						"inputFormat": "plain",
						"tags": [],
						"properties": {},
						"customClass": "",
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"dataGridLabel": false,
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"hideLabel": false,
						"tabindex": "",
						"disabled": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": {
						  "type": "input"
						},
						"attributes": {},
						"validateOn": "change",
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"mask": false,
						"id": "e69sxw"
					  },
					  {
						"autofocus": false,
						"input": true,
						"tableView": true,
						"inputType": "text",
						"inputMask": "",
						"label": "State",
						"key": "state",
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"defaultValue": "",
						"protected": false,
						"unique": false,
						"persistent": true,
						"hidden": false,
						"clearOnHide": true,
						"spellcheck": true,
						"validate": {
						  "required": false,
						  "minLength": "",
						  "maxLength": "",
						  "pattern": "",
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"type": "textfield",
						"labelPosition": "top",
						"inputFormat": "plain",
						"tags": [],
						"properties": {},
						"customClass": "",
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"dataGridLabel": false,
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"hideLabel": false,
						"tabindex": "",
						"disabled": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": {
						  "type": "input"
						},
						"attributes": {},
						"validateOn": "change",
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"mask": false,
						"id": "e5c173"
					  },
					  {
						"autofocus": false,
						"input": true,
						"tableView": true,
						"inputType": "text",
						"inputMask": "",
						"label": "Zipcode",
						"key": "zip",
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"defaultValue": "",
						"protected": false,
						"unique": false,
						"persistent": true,
						"hidden": false,
						"clearOnHide": true,
						"spellcheck": true,
						"validate": {
						  "required": false,
						  "minLength": "",
						  "maxLength": "",
						  "pattern": "",
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"type": "textfield",
						"labelPosition": "top",
						"inputFormat": "plain",
						"tags": [],
						"properties": {},
						"lockKey": true,
						"customClass": "",
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"dataGridLabel": false,
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"hideLabel": false,
						"tabindex": "",
						"disabled": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": {
						  "type": "input"
						},
						"attributes": {},
						"validateOn": "change",
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"mask": false,
						"id": "e6dl4w"
					  },
					  {
						"autofocus": false,
						"input": true,
						"tableView": true,
						"inputType": "text",
						"label": "Phone",
						"key": "phone",
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"protected": false,
						"unique": false,
						"persistent": true,
						"hidden": false,
						"defaultValue": "",
						"clearOnHide": true,
						"validate": {
						  "required": false,
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false,
						  "minLength": "",
						  "maxLength": "",
						  "pattern": ""
						},
						"type": "textfield",
						"labelPosition": "top",
						"inputFormat": "plain",
						"tags": [],
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"properties": {},
						"customClass": "",
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"dataGridLabel": false,
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"hideLabel": false,
						"tabindex": "",
						"disabled": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": {
						  "type": "input"
						},
						"attributes": {},
						"validateOn": "change",
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"mask": false,
						"spellcheck": true,
						"inputMode": "decimal",
						"id": "ej6ef7i",
						"inputMask": ""
					  },
					  {
						"autofocus": false,
						"input": true,
						"tableView": true,
						"inputType": "text",
						"label": "Email",
						"key": "email",
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"defaultValue": "",
						"protected": false,
						"unique": false,
						"persistent": true,
						"hidden": false,
						"clearOnHide": true,
						"kickbox": {
						  "enabled": false
						},
						"type": "textfield",
						"labelPosition": "top",
						"inputFormat": "plain",
						"tags": [],
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"properties": {},
						"customClass": "",
						"multiple": false,
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"dataGridLabel": false,
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"hideLabel": false,
						"tabindex": "",
						"disabled": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": {
						  "type": "input"
						},
						"attributes": {},
						"validateOn": "change",
						"validate": {
						  "required": false,
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false,
						  "minLength": "",
						  "maxLength": "",
						  "pattern": ""
						},
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"mask": false,
						"inputMask": "",
						"spellcheck": true,
						"id": "etcrpw"
					  },
					  {
						"autofocus": false,
						"input": true,
						"tableView": true,
						"inputType": "text",
						"inputMask": "",
						"label": "Website",
						"key": "website",
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"defaultValue": "",
						"protected": false,
						"unique": false,
						"persistent": true,
						"hidden": false,
						"clearOnHide": true,
						"spellcheck": true,
						"validate": {
						  "required": false,
						  "minLength": "",
						  "maxLength": "",
						  "pattern": "",
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"type": "textfield",
						"labelPosition": "top",
						"inputFormat": "plain",
						"tags": [],
						"properties": {},
						"customClass": "",
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"dataGridLabel": false,
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"hideLabel": false,
						"tabindex": "",
						"disabled": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": {
						  "type": "input"
						},
						"attributes": {},
						"validateOn": "change",
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"mask": false,
						"id": "en2l03ve"
					  },
					  {
						"autofocus": false,
						"input": true,
						"inputType": "checkbox",
						"tableView": true,
						"label": "Active",
						"dataGridLabel": false,
						"key": "active",
						"defaultValue": false,
						"protected": false,
						"persistent": true,
						"hidden": false,
						"name": "",
						"value": "",
						"clearOnHide": true,
						"validate": {
						  "required": false,
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"type": "checkbox",
						"labelPosition": "right",
						"tags": [],
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"properties": {},
						"hideLabel": false,
						"placeholder": "",
						"prefix": "",
						"customClass": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"tabindex": "",
						"disabled": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": null,
						"attributes": {},
						"validateOn": "change",
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "ecq5k"
					  },
					  {
						"autofocus": false,
						"input": true,
						"inputType": "checkbox",
						"tableView": true,
						"label": "Allow Backorders",
						"dataGridLabel": false,
						"key": "allowBackorders",
						"defaultValue": false,
						"protected": false,
						"persistent": true,
						"hidden": false,
						"name": "",
						"value": "",
						"clearOnHide": true,
						"validate": {
						  "required": false,
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"type": "checkbox",
						"labelPosition": "right",
						"tags": [],
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"properties": {},
						"lockKey": true,
						"hideLabel": false,
						"placeholder": "",
						"prefix": "",
						"customClass": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"tabindex": "",
						"disabled": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": null,
						"attributes": {},
						"validateOn": "change",
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "es4mfd9"
					  },
					  {
						"label": "Default Ship Date to Previous",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "defaultShipDatePrevious",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "es7ov",
						"defaultValue": false
					  },
					  {
						"label": "Invoice Only",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "isInvoiceOnly",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "esbf6sef",
						"defaultValue": false
					  },
					  {
						"label": "Allow Price Override",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "allowPriceOverride",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "e4irtygc",
						"defaultValue": false
					  },
					  {
						"label": "Enforce Minimums",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "enforceMinimums",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "eiprete",
						"defaultValue": false
					  },
					  {
						"label": "Split By Product Category",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "VSP_SplitByCategory",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "e748lzr",
						"defaultValue": false
					  },
					  {
						"label": "Split by Ship Date",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"defaultValue": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "VSP_SplitByShipDate",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "emhvyt"
					  },
					  {
						"label": "Split Order PDF",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"defaultValue": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "VSP_SplitOrdersIntoPDFs",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "ezv9u99"
					  },
					  {
						"label": "Showroom Vendor",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "isShowroomVendor",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "e1tic2b",
						"defaultValue": false
					  },
					  {
						"label": "Allow Manual Item Entry",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "allowManualItemEntry",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "evuvge",
						"defaultValue": false
					  },
					  {
						"label": "Enforce Purchase Increments",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "enforcePurchaseIncrement",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "evw3s6m",
						"defaultValue": false
					  },
					  {
						"label": "Use Credit Sheet",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "requireCreditSheet",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "ep67b0w",
						"defaultValue": false
					  },
					  {
						"label": "Allow Discounts",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "allowDiscounts",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "eewmjwh",
						"defaultValue": false
					  },
					  {
						"label": "Attach Orders to Email",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"defaultValue": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "VSP_UseDirectEmailAttachment",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "ekk4e8"
					  },
					  {
						"label": "Check Promotion on Order Complete",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"defaultValue": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "VSP_PromotionCheck",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "em2na6f"
					  },
					  {
						"label": "Process Payments",
						"description": "",
						"tooltip": "",
						"shortcut": "",
						"inputType": "checkbox",
						"customClass": "",
						"tabindex": "",
						"hidden": false,
						"hideLabel": false,
						"autofocus": false,
						"disabled": false,
						"tableView": false,
						"modalEdit": false,
						"defaultValue": false,
						"persistent": true,
						"protected": false,
						"dbIndex": false,
						"encrypted": false,
						"redrawOn": "",
						"clearOnHide": true,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"allowCalculateOverride": false,
						"validate": {
						  "required": false,
						  "customMessage": "",
						  "custom": "",
						  "customPrivate": false,
						  "json": "",
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"errorLabel": "",
						"key": "VSP_ProcessPayments",
						"tags": [],
						"properties": {},
						"conditional": {
						  "show": null,
						  "when": null,
						  "eq": "",
						  "json": ""
						},
						"customConditional": "",
						"logic": [],
						"attributes": {},
						"overlay": {
						  "style": "",
						  "page": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"type": "checkbox",
						"name": "",
						"value": "",
						"input": true,
						"placeholder": "",
						"prefix": "",
						"suffix": "",
						"multiple": false,
						"unique": false,
						"refreshOn": "",
						"dataGridLabel": true,
						"labelPosition": "right",
						"widget": null,
						"validateOn": "change",
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"id": "em2na6f"
					  }
					],
					"type": "panel",
					"breadcrumb": "default",
					"hideLabel": false,
					"tags": [],
					"conditional": {
					  "show": "",
					  "when": null,
					  "eq": ""
					},
					"properties": {},
					"placeholder": "",
					"prefix": "",
					"customClass": "",
					"suffix": "",
					"multiple": false,
					"defaultValue": null,
					"protected": false,
					"unique": false,
					"persistent": false,
					"hidden": false,
					"refreshOn": "",
					"redrawOn": "",
					"modalEdit": false,
					"label": "Panel",
					"dataGridLabel": false,
					"labelPosition": "top",
					"description": "",
					"errorLabel": "",
					"tooltip": "",
					"tabindex": "",
					"disabled": false,
					"autofocus": false,
					"dbIndex": false,
					"customDefaultValue": "",
					"calculateValue": "",
					"calculateServer": false,
					"widget": null,
					"attributes": {},
					"validateOn": "change",
					"validate": {
					  "required": false,
					  "custom": "",
					  "customPrivate": false,
					  "strictDateValidation": false,
					  "multiple": false,
					  "unique": false
					},
					"overlay": {
					  "style": "",
					  "left": "",
					  "top": "",
					  "width": "",
					  "height": ""
					},
					"allowCalculateOverride": false,
					"encrypted": false,
					"showCharCount": false,
					"showWordCount": false,
					"allowMultipleMasks": false,
					"tree": false,
					"id": "e53kxkp"
				  },
				  {
					"autofocus": false,
					"input": true,
					"tableView": true,
					"inputType": "number",
					"label": "Lead Time (days)",
					"key": "leadTime",
					"placeholder": "",
					"prefix": "",
					"suffix": "",
					"defaultValue": "",
					"protected": false,
					"persistent": true,
					"hidden": true,
					"clearOnHide": true,
					"validate": {
					  "required": false,
					  "min": "",
					  "max": "",
					  "step": "any",
					  "integer": "",
					  "multiple": "",
					  "custom": "",
					  "customPrivate": false,
					  "strictDateValidation": false,
					  "unique": false
					},
					"type": "number",
					"labelPosition": "top",
					"tags": [],
					"conditional": {
					  "show": "",
					  "when": null,
					  "eq": ""
					},
					"properties": {},
					"lockKey": true,
					"customClass": "",
					"multiple": false,
					"unique": false,
					"refreshOn": "",
					"redrawOn": "",
					"modalEdit": false,
					"dataGridLabel": false,
					"description": "",
					"errorLabel": "",
					"tooltip": "",
					"hideLabel": false,
					"tabindex": "",
					"disabled": false,
					"dbIndex": false,
					"customDefaultValue": "",
					"calculateValue": "",
					"calculateServer": false,
					"widget": {
					  "type": "input"
					},
					"attributes": {},
					"validateOn": "change",
					"overlay": {
					  "style": "",
					  "left": "",
					  "top": "",
					  "width": "",
					  "height": ""
					},
					"allowCalculateOverride": false,
					"encrypted": false,
					"showCharCount": false,
					"showWordCount": false,
					"allowMultipleMasks": false,
					"id": "ej3ziec"
				  }
				],
				"width": 6,
				"offset": 0,
				"push": 0,
				"pull": 0,
				"size": "md",
				"currentWidth": 6
			  },
			  {
				"components": [
				  {
					"clearOnHide": false,
					"key": "panel3ColumnsPanel2",
					"input": false,
					"title": "Order Transmission",
					"theme": "default",
					"tableView": false,
					"components": [
					  {
						"clearOnHide": false,
						"key": "panel",
						"input": false,
						"title": "Order Delivery",
						"theme": "default",
						"tableView": false,
						"components": [
						  {
							"autofocus": false,
							"input": true,
							"inputType": "checkbox",
							"tableView": true,
							"label": "Export Orders",
							"dataGridLabel": false,
							"key": "exportOrders",
							"defaultValue": false,
							"protected": false,
							"persistent": true,
							"hidden": false,
							"name": "",
							"value": "",
							"clearOnHide": true,
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false
							},
							"type": "checkbox",
							"labelPosition": "right",
							"tags": [],
							"conditional": {
							  "show": "",
							  "when": null,
							  "eq": ""
							},
							"properties": {},
							"hideLabel": false,
							"isNew": false,
							"placeholder": "",
							"prefix": "",
							"customClass": "",
							"suffix": "",
							"multiple": false,
							"unique": false,
							"refreshOn": "",
							"redrawOn": "",
							"modalEdit": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": null,
							"attributes": {},
							"validateOn": "change",
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"id": "elct83r"
						  },
						  {
							"autofocus": false,
							"input": true,
							"inputType": "checkbox",
							"tableView": true,
							"label": "Export Review Orders",
							"dataGridLabel": false,
							"key": "exportReviewOrders",
							"defaultValue": false,
							"protected": false,
							"persistent": true,
							"hidden": false,
							"name": "",
							"value": "",
							"clearOnHide": true,
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false
							},
							"type": "checkbox",
							"labelPosition": "right",
							"tags": [],
							"conditional": {
							  "show": "",
							  "when": null,
							  "eq": ""
							},
							"properties": {},
							"lockKey": true,
							"hideLabel": false,
							"placeholder": "",
							"prefix": "",
							"customClass": "",
							"suffix": "",
							"multiple": false,
							"unique": false,
							"refreshOn": "",
							"redrawOn": "",
							"modalEdit": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": null,
							"attributes": {},
							"validateOn": "change",
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"id": "e8mfoc"
						  },
						  {
							"autofocus": false,
							"input": true,
							"inputType": "checkbox",
							"tableView": true,
							"label": "Include Order File in Batch",
							"dataGridLabel": false,
							"key": "includeInBatch",
							"defaultValue": false,
							"protected": false,
							"persistent": true,
							"hidden": false,
							"name": "",
							"value": "",
							"clearOnHide": true,
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false
							},
							"type": "checkbox",
							"labelPosition": "right",
							"tags": [],
							"conditional": {
							  "show": "",
							  "when": null,
							  "eq": ""
							},
							"properties": {},
							"hideLabel": false,
							"isNew": false,
							"placeholder": "",
							"prefix": "",
							"customClass": "",
							"suffix": "",
							"multiple": false,
							"unique": false,
							"refreshOn": "",
							"redrawOn": "",
							"modalEdit": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": null,
							"attributes": {},
							"validateOn": "change",
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"id": "ezj0s9d"
						  },
						  {
							"autofocus": false,
							"input": true,
							"inputType": "checkbox",
							"tableView": true,
							"label": "Email Order Batches",
							"dataGridLabel": false,
							"key": "emailOrders",
							"defaultValue": false,
							"protected": false,
							"persistent": true,
							"hidden": false,
							"name": "",
							"value": "",
							"clearOnHide": true,
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false
							},
							"type": "checkbox",
							"labelPosition": "right",
							"tags": [],
							"conditional": {
							  "show": "",
							  "when": null,
							  "eq": ""
							},
							"properties": {},
							"hideLabel": false,
							"placeholder": "",
							"prefix": "",
							"customClass": "",
							"suffix": "",
							"multiple": false,
							"unique": false,
							"refreshOn": "",
							"redrawOn": "",
							"modalEdit": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": null,
							"attributes": {},
							"validateOn": "change",
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"id": "e3z7rav"
						  },
						  {
							"autofocus": false,
							"input": true,
							"tableView": true,
							"inputType": "email",
							"label": "Email Address for Order Batch",
							"key": "panelEmailAddressforOrderBatch",
							"placeholder": "",
							"prefix": "",
							"suffix": "",
							"defaultValue": "",
							"protected": false,
							"unique": false,
							"persistent": true,
							"hidden": false,
							"clearOnHide": true,
							"kickbox": {
							  "enabled": false
							},
							"type": "email",
							"labelPosition": "top",
							"inputFormat": "plain",
							"tags": [],
							"conditional": {
							  "show": "true",
							  "when": "emailOrders",
							  "eq": "true"
							},
							"properties": {},
							"customClass": "",
							"multiple": false,
							"refreshOn": "",
							"redrawOn": "",
							"modalEdit": false,
							"dataGridLabel": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"hideLabel": false,
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": {
							  "type": "input"
							},
							"attributes": {},
							"validateOn": "change",
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false,
							  "minLength": "",
							  "maxLength": "",
							  "pattern": ""
							},
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"mask": false,
							"inputMask": "",
							"spellcheck": true,
							"id": "efsypgj"
						  },
						  {
							"autofocus": false,
							"input": true,
							"tableView": true,
							"inputType": "time",
							"format": "HH:mm",
							"label": "Order Batches Daily Start Time",
							"key": "panelAutomatedDailyExportBeginTime",
							"placeholder": "",
							"prefix": "",
							"suffix": "",
							"defaultValue": "",
							"protected": false,
							"unique": false,
							"persistent": true,
							"hidden": true,
							"clearOnHide": true,
							"type": "time",
							"labelPosition": "top",
							"inputFormat": "plain",
							"tags": [],
							"conditional": {
							  "show": "",
							  "when": null,
							  "eq": ""
							},
							"properties": {},
							"customClass": "",
							"multiple": false,
							"refreshOn": "",
							"redrawOn": "",
							"modalEdit": false,
							"dataGridLabel": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"hideLabel": false,
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": {
							  "type": "input"
							},
							"attributes": {},
							"validateOn": "change",
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false,
							  "minLength": "",
							  "maxLength": "",
							  "pattern": ""
							},
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"mask": false,
							"inputMask": "99:99",
							"spellcheck": true,
							"dataFormat": "HH:mm:ss",
							"id": "e04w9oj"
						  },
						  {
							"autofocus": false,
							"input": true,
							"tableView": true,
							"label": "Frequency of Daily Order Batches",
							"key": "panelFrequencytoGenerateOrderBatches",
							"placeholder": "",
							"data": {
							  "values": [
								{
								  "value": "2Hours",
								  "label": "2 Hours"
								},
								{
								  "value": "4Hours",
								  "label": "4 Hours"
								},
								{
								  "value": "6Hours",
								  "label": "6 Hours"
								},
								{
								  "value": "8Hours",
								  "label": "8 Hours"
								},
								{
								  "value": "12Hours",
								  "label": "12 Hours"
								},
								{
								  "value": "24Hours",
								  "label": "24 hours"
								}
							  ],
							  "json": "",
							  "url": "",
							  "resource": "",
							  "custom": ""
							},
							"dataSrc": "values",
							"valueProperty": "",
							"defaultValue": "",
							"refreshOn": "",
							"filter": "",
							"authenticate": false,
							"template": "<span>{{ item.label }}</span>",
							"multiple": false,
							"protected": false,
							"unique": false,
							"persistent": true,
							"hidden": true,
							"clearOnHide": true,
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false
							},
							"type": "select",
							"labelPosition": "top",
							"tags": [],
							"conditional": {
							  "show": "",
							  "when": null,
							  "eq": ""
							},
							"properties": {},
							"prefix": "",
							"customClass": "",
							"suffix": "",
							"redrawOn": "",
							"modalEdit": false,
							"dataGridLabel": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"hideLabel": false,
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": null,
							"attributes": {},
							"validateOn": "change",
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"idPath": "id",
							"clearOnRefresh": false,
							"limit": 100,
							"lazyLoad": true,
							"searchEnabled": true,
							"searchField": "",
							"minSearch": 0,
							"readOnlyValue": false,
							"ignoreCache": false,
							"selectFields": "",
							"searchThreshold": 0.3,
							"uniqueOptions": false,
							"fuseOptions": {
							  "include": "score",
							  "threshold": 0.3
							},
							"customOptions": {},
							"useExactSearch": false,
							"id": "eo2u8ld"
						  },
						  {
							"autofocus": false,
							"input": true,
							"tableView": true,
							"label": "Order Batch Times",
							"key": "panelOrderBatchTimes",
							"placeholder": "",
							"data": {
							  "values": [
								{
								  "value": "1200Am",
								  "label": "12:00 am"
								},
								{
								  "value": "0100Am",
								  "label": "01:00 am"
								},
								{
								  "value": "0200Am",
								  "label": "02:00 am"
								},
								{
								  "value": "0300Am",
								  "label": "03:00 am"
								},
								{
								  "value": "0400Am",
								  "label": "04:00 am"
								},
								{
								  "value": "0500Am",
								  "label": "05:00 am"
								},
								{
								  "value": "0600Am",
								  "label": "06:00 am"
								},
								{
								  "value": "0700Am",
								  "label": "07:00 am"
								},
								{
								  "value": "0800Am",
								  "label": "08:00 am"
								},
								{
								  "value": "0900Am",
								  "label": "09:00 am"
								},
								{
								  "value": "1000Am",
								  "label": "10:00 am"
								},
								{
								  "value": "1100Am",
								  "label": "11:00 am"
								},
								{
								  "value": "1200Pm",
								  "label": "12:00 pm"
								},
								{
								  "value": "0100Pm",
								  "label": "01:00 pm"
								},
								{
								  "value": "0200Pm",
								  "label": "02:00 pm"
								},
								{
								  "value": "0300Pm",
								  "label": "03:00 pm"
								},
								{
								  "value": "0400Pm",
								  "label": "04:00 pm"
								},
								{
								  "value": "0500Pm",
								  "label": "05:00 pm"
								},
								{
								  "value": "0600Pm",
								  "label": "06:00 pm"
								},
								{
								  "value": "0700Pm",
								  "label": "07:00 pm"
								},
								{
								  "value": "0800Pm",
								  "label": "08:00 pm"
								},
								{
								  "value": "0900Pm",
								  "label": "09:00 pm"
								},
								{
								  "value": "1000Pm",
								  "label": "10:00 pm"
								},
								{
								  "value": "1100Pm",
								  "label": "11:00 pm"
								}
							  ],
							  "json": "",
							  "url": "",
							  "resource": "",
							  "custom": ""
							},
							"dataSrc": "values",
							"valueProperty": "",
							"defaultValue": "",
							"refreshOn": "",
							"filter": "",
							"authenticate": false,
							"template": "<span>{{ item.label }}</span>",
							"multiple": true,
							"protected": false,
							"unique": false,
							"persistent": true,
							"hidden": true,
							"clearOnHide": true,
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false
							},
							"type": "select",
							"labelPosition": "top",
							"tags": [],
							"conditional": {
							  "show": "",
							  "when": null,
							  "eq": ""
							},
							"properties": {},
							"prefix": "",
							"customClass": "",
							"suffix": "",
							"redrawOn": "",
							"modalEdit": false,
							"dataGridLabel": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"hideLabel": false,
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": null,
							"attributes": {},
							"validateOn": "change",
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"idPath": "id",
							"clearOnRefresh": false,
							"limit": 100,
							"lazyLoad": true,
							"searchEnabled": true,
							"searchField": "",
							"minSearch": 0,
							"readOnlyValue": false,
							"ignoreCache": false,
							"selectFields": "",
							"searchThreshold": 0.3,
							"uniqueOptions": false,
							"fuseOptions": {
							  "include": "score",
							  "threshold": 0.3
							},
							"customOptions": {},
							"useExactSearch": false,
							"id": "e3ovgi"
						  },
						//   {
						// 	"label": "Export Destination",
						// 	"labelPosition": "top",
						// 	"widget": "choicesjs",
						// 	"placeholder": "",
						// 	"description": "",
						// 	"tooltip": "",
						// 	"customClass": "",
						// 	"tabindex": "",
						// 	"hidden": false,
						// 	"hideLabel": false,
						// 	"uniqueOptions": false,
						// 	"autofocus": false,
						// 	"disabled": false,
						// 	"tableView": true,
						// 	"modalEdit": false,
						// 	"multiple": false,
						// 	"dataSrc": "values",
						// 	"data": {
						// 	  "values": [
						// 		{
						// 		  "value": "OCAWS",
						// 		  "label": "OCAWS"
						// 		},
						// 		{
						// 		  "value": "AWS",
						// 		  "label": "AWS"
						// 		},
						// 		{
						// 		  "value": "localDirectory",
						// 		  "label": "LOCAL DIRECTORY"
						// 		},
						// 		{
						// 		  "value": "salesforce",
						// 		  "label": "SALESFORCE"
						// 		},
						// 		{
						// 		  "value": "toagency",
						// 		  "label": "TOAGENCY"
						// 		}
						// 	  ],
						// 	  "resource": "",
						// 	  "json": "",
						// 	  "url": "",
						// 	  "custom": ""
						// 	},
						// 	"dataType": "",
						// 	"idPath": "id",
						// 	"valueProperty": "",
						// 	"template": "<span>{{ item.label }}</span>",
						// 	"refreshOn": "",
						// 	"refreshOnBlur": "",
						// 	"clearOnRefresh": false,
						// 	"searchEnabled": true,
						// 	"selectThreshold": 0.3,
						// 	"readOnlyValue": false,
						// 	"customOptions": {},
						// 	"useExactSearch": false,
						// 	"persistent": true,
						// 	"protected": false,
						// 	"dbIndex": false,
						// 	"encrypted": false,
						// 	"clearOnHide": true,
						// 	"customDefaultValue": "",
						// 	"calculateValue": "",
						// 	"calculateServer": false,
						// 	"allowCalculateOverride": false,
						// 	"validateOn": "change",
						// 	"validate": {
						// 	  "required": false,
						// 	  "onlyAvailableItems": false,
						// 	  "customMessage": "",
						// 	  "custom": "",
						// 	  "customPrivate": false,
						// 	  "json": "",
						// 	  "strictDateValidation": false,
						// 	  "multiple": false,
						// 	  "unique": false
						// 	},
						// 	"unique": false,
						// 	"errorLabel": "",
						// 	"key": "VSP_VendorExportDestinationType",
						// 	"tags": [],
						// 	"properties": {},
						// 	"conditional": {
						// 	  "show": null,
						// 	  "when": null,
						// 	  "eq": "",
						// 	  "json": ""
						// 	},
						// 	"customConditional": "",
						// 	"logic": [],
						// 	"attributes": {},
						// 	"overlay": {
						// 	  "style": "",
						// 	  "page": "",
						// 	  "left": "",
						// 	  "top": "",
						// 	  "width": "",
						// 	  "height": ""
						// 	},
						// 	"type": "select",
						// 	"indexeddb": {
						// 	  "filter": {}
						// 	},
						// 	"selectFields": "",
						// 	"searchField": "",
						// 	"minSearch": 0,
						// 	"filter": "",
						// 	"limit": 100,
						// 	"redrawOn": "",
						// 	"input": true,
						// 	"prefix": "",
						// 	"suffix": "",
						// 	"dataGridLabel": false,
						// 	"showCharCount": false,
						// 	"showWordCount": false,
						// 	"allowMultipleMasks": false,
						// 	"lazyLoad": true,
						// 	"authenticate": false,
						// 	"ignoreCache": false,
						// 	"searchThreshold": 0.3,
						// 	"fuseOptions": {
						// 	  "include": "score",
						// 	  "threshold": 0.3
						// 	},
						// 	"id": "eoaa37q",
						// 	"defaultValue": ""
						//   }
						],
						"type": "panel",
						"breadcrumb": "default",
						"tags": [],
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"properties": {},
						"hideLabel": false,
						"placeholder": "",
						"prefix": "",
						"customClass": "",
						"suffix": "",
						"multiple": false,
						"defaultValue": null,
						"protected": false,
						"unique": false,
						"persistent": false,
						"hidden": false,
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"label": "Panel",
						"dataGridLabel": false,
						"labelPosition": "top",
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"tabindex": "",
						"disabled": false,
						"autofocus": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": null,
						"attributes": {},
						"validateOn": "change",
						"validate": {
						  "required": false,
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"tree": false,
						"id": "ewng7ms"
					  },
					  {
						"clearOnHide": false,
						"key": "panel3ColumnsPanel2Panel",
						"input": false,
						"title": "Order Report",
						"theme": "default",
						"tableView": false,
						"components": [
						  {
							"autofocus": false,
							"input": true,
							"tableView": true,
							"inputType": "radio",
							"label": "Select Order Format",
							"key": "VSP_OrderFormat",
							"values": [
							  {
								"value": "withoutImage",
								"label": "Without Image",
								"shortcut": ""
							  },
							  {
								"value": "withImageMedium",
								"label": "With Image - Medium",
								"shortcut": ""
							  },
							  {
								"value": "withImageLarge",
								"label": "With Image - Large",
								"shortcut": ""
							  }
							],
							"defaultValue": "",
							"protected": false,
							"fieldSet": false,
							"persistent": true,
							"hidden": false,
							"clearOnHide": true,
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false
							},
							"type": "radio",
							"labelPosition": "top",
							"optionsLabelPosition": "right",
							"tags": [],
							"conditional": {
							  "show": "",
							  "when": null,
							  "eq": ""
							},
							"properties": {},
							"hideLabel": true,
							"placeholder": "",
							"prefix": "",
							"customClass": "",
							"suffix": "",
							"multiple": false,
							"unique": false,
							"refreshOn": "",
							"redrawOn": "",
							"modalEdit": false,
							"dataGridLabel": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": null,
							"attributes": {},
							"validateOn": "change",
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"id": "emey6ec"
						  }
						],
						"type": "panel",
						"breadcrumb": "default",
						"hideLabel": false,
						"tags": [],
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"properties": {},
						"placeholder": "",
						"prefix": "",
						"customClass": "",
						"suffix": "",
						"multiple": false,
						"defaultValue": null,
						"protected": false,
						"unique": false,
						"persistent": false,
						"hidden": false,
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"label": "Panel",
						"dataGridLabel": false,
						"labelPosition": "top",
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"tabindex": "",
						"disabled": false,
						"autofocus": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": null,
						"attributes": {},
						"validateOn": "change",
						"validate": {
						  "required": false,
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"tree": false,
						"id": "epdfq34"
					  },
					  {
						"clearOnHide": false,
						"key": "panelPanel",
						"input": false,
						"title": "Order Information",
						"theme": "default",
						"tableView": false,
						"components": [
						  {
							"autofocus": false,
							"input": true,
							"inputType": "checkbox",
							"tableView": true,
							"label": "Review order if Vendor Customer ID is missing",
							"dataGridLabel": false,
							"key": "useVendorCustId",
							"defaultValue": false,
							"protected": false,
							"persistent": true,
							"hidden": false,
							"name": "",
							"value": "",
							"clearOnHide": true,
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false
							},
							"type": "checkbox",
							"labelPosition": "right",
							"tags": [],
							"conditional": {
							  "show": "",
							  "when": null,
							  "eq": ""
							},
							"properties": {},
							"lockKey": true,
							"hideLabel": false,
							"isNew": false,
							"placeholder": "",
							"prefix": "",
							"customClass": "",
							"suffix": "",
							"multiple": false,
							"unique": false,
							"refreshOn": "",
							"redrawOn": "",
							"modalEdit": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": null,
							"attributes": {},
							"validateOn": "change",
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"id": "eso5xx"
						  },
						  {
							"autofocus": false,
							"input": true,
							"inputType": "checkbox",
							"tableView": true,
							"label": "Review order if Vendor Ship ID is missing",
							"dataGridLabel": false,
							"key": "useVendorShipId",
							"defaultValue": false,
							"protected": false,
							"persistent": true,
							"hidden": false,
							"name": "",
							"value": "",
							"clearOnHide": true,
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false
							},
							"type": "checkbox",
							"labelPosition": "right",
							"tags": [],
							"conditional": {
							  "show": "",
							  "when": null,
							  "eq": ""
							},
							"properties": {},
							"lockKey": true,
							"hideLabel": false,
							"placeholder": "",
							"prefix": "",
							"customClass": "",
							"suffix": "",
							"multiple": false,
							"unique": false,
							"refreshOn": "",
							"redrawOn": "",
							"modalEdit": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": null,
							"attributes": {},
							"validateOn": "change",
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"id": "em81nagj7"
						  },
						  {
							"autofocus": false,
							"input": true,
							"inputType": "checkbox",
							"tableView": true,
							"label": "Review order if Vendor Term ID is missing",
							"dataGridLabel": false,
							"key": "useVendorTerms",
							"defaultValue": false,
							"protected": false,
							"persistent": true,
							"hidden": false,
							"name": "",
							"value": "",
							"clearOnHide": true,
							"validate": {
							  "required": false,
							  "custom": "",
							  "customPrivate": false,
							  "strictDateValidation": false,
							  "multiple": false,
							  "unique": false
							},
							"type": "checkbox",
							"labelPosition": "right",
							"tags": [],
							"conditional": {
							  "show": "",
							  "when": null,
							  "eq": ""
							},
							"properties": {},
							"lockKey": true,
							"hideLabel": false,
							"placeholder": "",
							"prefix": "",
							"customClass": "",
							"suffix": "",
							"multiple": false,
							"unique": false,
							"refreshOn": "",
							"redrawOn": "",
							"modalEdit": false,
							"description": "",
							"errorLabel": "",
							"tooltip": "",
							"tabindex": "",
							"disabled": false,
							"dbIndex": false,
							"customDefaultValue": "",
							"calculateValue": "",
							"calculateServer": false,
							"widget": null,
							"attributes": {},
							"validateOn": "change",
							"overlay": {
							  "style": "",
							  "left": "",
							  "top": "",
							  "width": "",
							  "height": ""
							},
							"allowCalculateOverride": false,
							"encrypted": false,
							"showCharCount": false,
							"showWordCount": false,
							"allowMultipleMasks": false,
							"id": "e3s8c6"
						  }
						],
						"type": "panel",
						"breadcrumb": "default",
						"tags": [],
						"conditional": {
						  "show": "",
						  "when": null,
						  "eq": ""
						},
						"properties": {},
						"hideLabel": false,
						"placeholder": "",
						"prefix": "",
						"customClass": "",
						"suffix": "",
						"multiple": false,
						"defaultValue": null,
						"protected": false,
						"unique": false,
						"persistent": false,
						"hidden": false,
						"refreshOn": "",
						"redrawOn": "",
						"modalEdit": false,
						"label": "Panel",
						"dataGridLabel": false,
						"labelPosition": "top",
						"description": "",
						"errorLabel": "",
						"tooltip": "",
						"tabindex": "",
						"disabled": false,
						"autofocus": false,
						"dbIndex": false,
						"customDefaultValue": "",
						"calculateValue": "",
						"calculateServer": false,
						"widget": null,
						"attributes": {},
						"validateOn": "change",
						"validate": {
						  "required": false,
						  "custom": "",
						  "customPrivate": false,
						  "strictDateValidation": false,
						  "multiple": false,
						  "unique": false
						},
						"overlay": {
						  "style": "",
						  "left": "",
						  "top": "",
						  "width": "",
						  "height": ""
						},
						"allowCalculateOverride": false,
						"encrypted": false,
						"showCharCount": false,
						"showWordCount": false,
						"allowMultipleMasks": false,
						"tree": false,
						"id": "e6ifpha7j"
					  }
					],
					"type": "panel",
					"breadcrumb": "default",
					"hideLabel": false,
					"tags": [],
					"conditional": {
					  "show": "",
					  "when": null,
					  "eq": ""
					},
					"properties": {},
					"placeholder": "",
					"prefix": "",
					"customClass": "",
					"suffix": "",
					"multiple": false,
					"defaultValue": null,
					"protected": false,
					"unique": false,
					"persistent": false,
					"hidden": false,
					"refreshOn": "",
					"redrawOn": "",
					"modalEdit": false,
					"label": "Panel",
					"dataGridLabel": false,
					"labelPosition": "top",
					"description": "",
					"errorLabel": "",
					"tooltip": "",
					"tabindex": "",
					"disabled": false,
					"autofocus": false,
					"dbIndex": false,
					"customDefaultValue": "",
					"calculateValue": "",
					"calculateServer": false,
					"widget": null,
					"attributes": {},
					"validateOn": "change",
					"validate": {
					  "required": false,
					  "custom": "",
					  "customPrivate": false,
					  "strictDateValidation": false,
					  "multiple": false,
					  "unique": false
					},
					"overlay": {
					  "style": "",
					  "left": "",
					  "top": "",
					  "width": "",
					  "height": ""
					},
					"allowCalculateOverride": false,
					"encrypted": false,
					"showCharCount": false,
					"showWordCount": false,
					"allowMultipleMasks": false,
					"tree": false,
					"id": "ex42spj"
				  }
				],
				"width": 6,
				"offset": 0,
				"push": 0,
				"pull": 0,
				"size": "md",
				"currentWidth": 6
			  }
			],
			"type": "columns",
			"hideLabel": false,
			"tags": [],
			"conditional": {
			  "show": "",
			  "when": null,
			  "eq": ""
			},
			"properties": {},
			"placeholder": "",
			"prefix": "",
			"customClass": "",
			"suffix": "",
			"multiple": false,
			"defaultValue": null,
			"protected": false,
			"unique": false,
			"persistent": false,
			"hidden": false,
			"refreshOn": "",
			"redrawOn": "",
			"modalEdit": false,
			"dataGridLabel": false,
			"labelPosition": "top",
			"description": "",
			"errorLabel": "",
			"tooltip": "",
			"tabindex": "",
			"disabled": false,
			"autofocus": false,
			"dbIndex": false,
			"customDefaultValue": "",
			"calculateValue": "",
			"calculateServer": false,
			"widget": null,
			"attributes": {},
			"validateOn": "change",
			"validate": {
			  "required": false,
			  "custom": "",
			  "customPrivate": false,
			  "strictDateValidation": false,
			  "multiple": false,
			  "unique": false
			},
			"overlay": {
			  "style": "",
			  "left": "",
			  "top": "",
			  "width": "",
			  "height": ""
			},
			"allowCalculateOverride": false,
			"encrypted": false,
			"showCharCount": false,
			"showWordCount": false,
			"allowMultipleMasks": false,
			"tree": false,
			"autoAdjust": false,
			"id": "e9bvrf"
		  }
		],
		"type": "panel",
		"breadcrumb": "default",
		"hideLabel": false,
		"tags": [],
		"conditional": {
		  "show": "",
		  "when": null,
		  "eq": ""
		},
		"properties": {},
		"placeholder": "",
		"prefix": "",
		"customClass": "",
		"suffix": "",
		"multiple": false,
		"defaultValue": null,
		"protected": false,
		"unique": false,
		"persistent": false,
		"hidden": false,
		"refreshOn": "",
		"redrawOn": "",
		"modalEdit": false,
		"label": "Panel",
		"dataGridLabel": false,
		"labelPosition": "top",
		"description": "",
		"errorLabel": "",
		"tooltip": "",
		"tabindex": "",
		"disabled": false,
		"autofocus": false,
		"dbIndex": false,
		"customDefaultValue": "",
		"calculateValue": "",
		"calculateServer": false,
		"widget": null,
		"attributes": {},
		"validateOn": "change",
		"validate": {
		  "required": false,
		  "custom": "",
		  "customPrivate": false,
		  "strictDateValidation": false,
		  "multiple": false,
		  "unique": false
		},
		"overlay": {
		  "style": "",
		  "left": "",
		  "top": "",
		  "width": "",
		  "height": ""
		},
		"allowCalculateOverride": false,
		"encrypted": false,
		"showCharCount": false,
		"showWordCount": false,
		"allowMultipleMasks": false,
		"tree": false,
		"id": "e5e90av"
	  },
	  {
		"autofocus": false,
		"input": true,
		"tableView": true,
		"label": "Note",
		"key": "note",
		"placeholder": "",
		"prefix": "",
		"suffix": "",
		"rows": 3,
		"multiple": false,
		"defaultValue": "",
		"protected": false,
		"persistent": true,
		"hidden": false,
		"wysiwyg": false,
		"clearOnHide": true,
		"spellcheck": true,
		"validate": {
		  "required": false,
		  "minLength": "",
		  "maxLength": "",
		  "pattern": "",
		  "custom": "",
		  "customPrivate": false,
		  "strictDateValidation": false,
		  "multiple": false,
		  "unique": false,
		  "minWords": "",
		  "maxWords": ""
		},
		"type": "textarea",
		"labelPosition": "top",
		"inputFormat": "plain",
		"tags": [],
		"conditional": {
		  "show": "",
		  "when": null,
		  "eq": ""
		},
		"properties": {},
		"customClass": "",
		"unique": false,
		"refreshOn": "",
		"redrawOn": "",
		"modalEdit": false,
		"dataGridLabel": false,
		"description": "",
		"errorLabel": "",
		"tooltip": "",
		"hideLabel": false,
		"tabindex": "",
		"disabled": false,
		"dbIndex": false,
		"customDefaultValue": "",
		"calculateValue": "",
		"calculateServer": false,
		"widget": {
		  "type": "input"
		},
		"attributes": {},
		"validateOn": "change",
		"overlay": {
		  "style": "",
		  "left": "",
		  "top": "",
		  "width": "",
		  "height": ""
		},
		"allowCalculateOverride": false,
		"encrypted": false,
		"showCharCount": false,
		"showWordCount": false,
		"allowMultipleMasks": false,
		"mask": false,
		"inputType": "text",
		"inputMask": "",
		"editor": "",
		"fixedSize": true,
		"id": "ejfjyjv"
	  },
	  {
		"autofocus": false,
		"input": true,
		"tableView": true,
		"inputType": "text",
		"inputMask": "",
		"label": "Order Tag Line",
		"key": "orderTagLine",
		"placeholder": "",
		"prefix": "",
		"suffix": "",
		"multiple": false,
		"defaultValue": "",
		"protected": false,
		"unique": false,
		"persistent": true,
		"hidden": false,
		"clearOnHide": true,
		"spellcheck": true,
		"validate": {
		  "required": false,
		  "minLength": "",
		  "maxLength": "",
		  "pattern": "",
		  "custom": "",
		  "customPrivate": false,
		  "strictDateValidation": false,
		  "multiple": false,
		  "unique": false
		},
		"conditional": {
		  "show": "",
		  "when": null,
		  "eq": ""
		},
		"type": "textfield",
		"labelPosition": "top",
		"inputFormat": "plain",
		"tags": [],
		"properties": {},
		"customClass": "",
		"refreshOn": "",
		"redrawOn": "",
		"modalEdit": false,
		"dataGridLabel": false,
		"description": "",
		"errorLabel": "",
		"tooltip": "",
		"hideLabel": false,
		"tabindex": "",
		"disabled": false,
		"dbIndex": false,
		"customDefaultValue": "",
		"calculateValue": "",
		"calculateServer": false,
		"widget": {
		  "type": "input"
		},
		"attributes": {},
		"validateOn": "change",
		"overlay": {
		  "style": "",
		  "left": "",
		  "top": "",
		  "width": "",
		  "height": ""
		},
		"allowCalculateOverride": false,
		"encrypted": false,
		"showCharCount": false,
		"showWordCount": false,
		"allowMultipleMasks": false,
		"mask": false,
		"id": "en2l03ve"
	  },
	  {
		"label": "Cart Message Type",
		"labelPosition": "top",
		"widget": "choicesjs",
		"placeholder": "",
		"description": "",
		"tooltip": "",
		"customClass": "",
		"tabindex": "",
		"hidden": false,
		"hideLabel": false,
		"uniqueOptions": false,
		"autofocus": false,
		"disabled": false,
		"tableView": true,
		"modalEdit": false,
		"multiple": false,
		"dataSrc": "values",
		"data": {
		  "values": [
			{
			  "value": "Alert",
			  "label": "Alert"
			},
			{
			  "value": "Notification",
			  "label": "Notification"
			}
		  ],
		  "resource": "",
		  "json": "",
		  "url": "",
		  "custom": ""
		},
		"dataType": "",
		"idPath": "id",
		"valueProperty": "",
		"template": "<span>{{ item.label }}</span>",
		"refreshOn": "",
		"refreshOnBlur": "",
		"clearOnRefresh": false,
		"searchEnabled": true,
		"selectThreshold": 0.3,
		"readOnlyValue": false,
		"customOptions": {},
		"useExactSearch": false,
		"persistent": true,
		"protected": false,
		"dbIndex": false,
		"encrypted": false,
		"clearOnHide": true,
		"customDefaultValue": "",
		"calculateValue": "",
		"calculateServer": false,
		"allowCalculateOverride": false,
		"validateOn": "change",
		"validate": {
		  "required": false,
		  "onlyAvailableItems": false,
		  "customMessage": "",
		  "custom": "",
		  "customPrivate": false,
		  "json": "",
		  "strictDateValidation": false,
		  "multiple": false,
		  "unique": false
		},
		"unique": false,
		"errorLabel": "",
		"key": "VSP_CartMessageType",
		"tags": [],
		"properties": {},
		"conditional": {
		  "show": null,
		  "when": null,
		  "eq": "",
		  "json": ""
		},
		"customConditional": "",
		"logic": [],
		"attributes": {},
		"overlay": {
		  "style": "",
		  "page": "",
		  "left": "",
		  "top": "",
		  "width": "",
		  "height": ""
		},
		"type": "select",
		"indexeddb": {
		  "filter": {}
		},
		"selectFields": "",
		"searchField": "",
		"minSearch": 0,
		"filter": "",
		"limit": 100,
		"redrawOn": "",
		"input": true,
		"prefix": "",
		"suffix": "",
		"dataGridLabel": false,
		"showCharCount": false,
		"showWordCount": false,
		"allowMultipleMasks": false,
		"lazyLoad": true,
		"authenticate": false,
		"ignoreCache": false,
		"searchThreshold": 0.3,
		"fuseOptions": {
		  "include": "score",
		  "threshold": 0.3
		},
		"id": "eoaa37q",
		"defaultValue": ""
	  },
	  {
		"label": "Cart Message",
		"labelPosition": "top",
		"placeholder": "",
		"description": "",
		"tooltip": "",
		"prefix": "",
		"suffix": "",
		"widget": {
		  "type": "input"
		},
		"editor": "",
		"autoExpand": false,
		"customClass": "",
		"tabindex": "",
		"autocomplete": "",
		"hidden": false,
		"hideLabel": false,
		"showWordCount": false,
		"showCharCount": false,
		"autofocus": false,
		"spellcheck": true,
		"disabled": false,
		"tableView": true,
		"modalEdit": false,
		"multiple": false,
		"persistent": true,
		"inputFormat": "html",
		"protected": false,
		"dbIndex": false,
		"case": "",
		"encrypted": false,
		"redrawOn": "",
		"clearOnHide": true,
		"customDefaultValue": "",
		"calculateValue": "",
		"calculateServer": false,
		"allowCalculateOverride": false,
		"validateOn": "change",
		"validate": {
		  "required": false,
		  "pattern": "",
		  "customMessage": "",
		  "custom": "",
		  "customPrivate": false,
		  "json": "",
		  "minLength": "",
		  "maxLength": "",
		  "minWords": "",
		  "maxWords": "",
		  "strictDateValidation": false,
		  "multiple": false,
		  "unique": false
		},
		"unique": false,
		"errorLabel": "",
		"key": "VSP_CartMessage",
		"tags": [],
		"properties": {},
		"conditional": {
		  "show": null,
		  "when": null,
		  "eq": "",
		  "json": ""
		},
		"customConditional": "",
		"logic": [],
		"attributes": {},
		"overlay": {
		  "style": "",
		  "page": "",
		  "left": "",
		  "top": "",
		  "width": "",
		  "height": ""
		},
		"type": "textarea",
		"rows": 3,
		"wysiwyg": false,
		"input": true,
		"refreshOn": "",
		"dataGridLabel": false,
		"allowMultipleMasks": false,
		"mask": false,
		"inputType": "text",
		"inputMask": "",
		"fixedSize": true,
		"id": "e6qhtt4",
		"defaultValue": ""
	  },
	  {
		"label": "Columns",
		"columns": [
		  {
			"components": [
			  {
				"clearOnHide": false,
				"key": "panel2",
				"input": false,
				"title": "Agency",
				"theme": "default",
				"tableView": false,
				"components": [
				  {
					"autofocus": false,
					"input": true,
					"tableView": true,
					"inputType": "number",
					"label": "Commission %",
					"key": "commissionPercent",
					"placeholder": "",
					"prefix": "",
					"suffix": "",
					"defaultValue": "",
					"protected": false,
					"persistent": true,
					"hidden": false,
					"clearOnHide": true,
					"validate": {
					  "required": false,
					  "min": "",
					  "max": "",
					  "step": "any",
					  "integer": "",
					  "multiple": "",
					  "custom": "",
					  "customPrivate": false,
					  "strictDateValidation": false,
					  "unique": false
					},
					"type": "number",
					"labelPosition": "top",
					"tags": [],
					"conditional": {
					  "show": "",
					  "when": null,
					  "eq": ""
					},
					"properties": {},
					"lockKey": true,
					"customClass": "",
					"multiple": false,
					"unique": false,
					"refreshOn": "",
					"redrawOn": "",
					"modalEdit": false,
					"dataGridLabel": false,
					"description": "",
					"errorLabel": "",
					"tooltip": "",
					"hideLabel": false,
					"tabindex": "",
					"disabled": false,
					"dbIndex": false,
					"customDefaultValue": "",
					"calculateValue": "",
					"calculateServer": false,
					"widget": {
					  "type": "input"
					},
					"attributes": {},
					"validateOn": "change",
					"overlay": {
					  "style": "",
					  "left": "",
					  "top": "",
					  "width": "",
					  "height": ""
					},
					"allowCalculateOverride": false,
					"encrypted": false,
					"showCharCount": false,
					"showWordCount": false,
					"allowMultipleMasks": false,
					"id": "ewugtmk"
				  },
				  {
					"autofocus": false,
					"input": true,
					"tableView": true,
					"inputType": "text",
					"inputMask": "",
					"label": "Order Minimum",
					"key": "orderMinimum",
					"placeholder": "",
					"prefix": "",
					"suffix": "",
					"defaultValue": "",
					"protected": false,
					"persistent": true,
					"hidden": false,
					"clearOnHide": true,
					"delimiter": true,
					"decimalLimit": 2,
					"requireDecimal": true,
					"validate": {
					  "required": false,
					  "multiple": "",
					  "custom": "",
					  "customPrivate": false,
					  "strictDateValidation": false,
					  "unique": false,
					  "min": "",
					  "max": "",
					  "step": "any",
					  "integer": ""
					},
					"conditional": {
					  "show": "",
					  "when": null,
					  "eq": ""
					},
					"type": "currency",
					"labelPosition": "top",
					"tags": [],
					"properties": {},
					"lockKey": true,
					"isNew": false,
					"customClass": "",
					"multiple": false,
					"unique": false,
					"refreshOn": "",
					"redrawOn": "",
					"modalEdit": false,
					"dataGridLabel": false,
					"description": "",
					"errorLabel": "",
					"tooltip": "",
					"hideLabel": false,
					"tabindex": "",
					"disabled": false,
					"dbIndex": false,
					"customDefaultValue": "",
					"calculateValue": "",
					"calculateServer": false,
					"widget": {
					  "type": "input"
					},
					"attributes": {},
					"validateOn": "change",
					"overlay": {
					  "style": "",
					  "left": "",
					  "top": "",
					  "width": "",
					  "height": ""
					},
					"allowCalculateOverride": false,
					"encrypted": false,
					"showCharCount": false,
					"showWordCount": false,
					"allowMultipleMasks": false,
					"id": "evtg06c"
				  },
				  {
					"autofocus": false,
					"input": true,
					"tableView": true,
					"inputType": "text",
					"inputMask": "",
					"label": "Re-Order Minimum",
					"key": "reOrderMinimum",
					"placeholder": "",
					"prefix": "",
					"suffix": "",
					"defaultValue": "",
					"protected": false,
					"persistent": true,
					"hidden": false,
					"clearOnHide": true,
					"delimiter": true,
					"decimalLimit": 2,
					"requireDecimal": true,
					"validate": {
					  "required": false,
					  "multiple": "",
					  "custom": "",
					  "customPrivate": false,
					  "strictDateValidation": false,
					  "unique": false,
					  "min": "",
					  "max": "",
					  "step": "any",
					  "integer": ""
					},
					"conditional": {
					  "show": "",
					  "when": null,
					  "eq": ""
					},
					"type": "currency",
					"labelPosition": "top",
					"tags": [],
					"properties": {},
					"lockKey": true,
					"customClass": "",
					"multiple": false,
					"unique": false,
					"refreshOn": "",
					"redrawOn": "",
					"modalEdit": false,
					"dataGridLabel": false,
					"description": "",
					"errorLabel": "",
					"tooltip": "",
					"hideLabel": false,
					"tabindex": "",
					"disabled": false,
					"dbIndex": false,
					"customDefaultValue": "",
					"calculateValue": "",
					"calculateServer": false,
					"widget": {
					  "type": "input"
					},
					"attributes": {},
					"validateOn": "change",
					"overlay": {
					  "style": "",
					  "left": "",
					  "top": "",
					  "width": "",
					  "height": ""
					},
					"allowCalculateOverride": false,
					"encrypted": false,
					"showCharCount": false,
					"showWordCount": false,
					"allowMultipleMasks": false,
					"id": "e6xj4m"
				  },
				  {
					"label": "Minimum Balance",
					"labelPosition": "top",
					"placeholder": "",
					"description": "",
					"tooltip": "",
					"prefix": "",
					"suffix": "",
					"widget": {
					  "type": "input"
					},
					"customClass": "",
					"tabindex": "",
					"autocomplete": "",
					"hidden": false,
					"hideLabel": false,
					"mask": false,
					"autofocus": false,
					"spellcheck": true,
					"disabled": false,
					"tableView": true,
					"modalEdit": false,
					"multiple": false,
					"persistent": true,
					"currency": "USD",
					"inputFormat": "plain",
					"protected": false,
					"dbIndex": false,
					"case": "",
					"encrypted": false,
					"redrawOn": "",
					"clearOnHide": true,
					"customDefaultValue": "",
					"calculateValue": "",
					"calculateServer": false,
					"allowCalculateOverride": false,
					"validateOn": "change",
					"validate": {
					  "required": false,
					  "customMessage": "",
					  "custom": "",
					  "customPrivate": false,
					  "json": "",
					  "strictDateValidation": false,
					  "multiple": false,
					  "unique": false,
					  "min": "",
					  "max": "",
					  "step": "any",
					  "integer": ""
					},
					"unique": false,
					"errorLabel": "",
					"key": "minimumBalance",
					"tags": [],
					"properties": {},
					"conditional": {
					  "show": null,
					  "when": null,
					  "eq": "",
					  "json": ""
					},
					"customConditional": "",
					"logic": [],
					"attributes": {},
					"overlay": {
					  "style": "",
					  "page": "",
					  "left": "",
					  "top": "",
					  "width": "",
					  "height": ""
					},
					"type": "currency",
					"input": true,
					"inputType": "text",
					"delimiter": true,
					"decimalLimit": 2,
					"requireDecimal": true,
					"lockKey": true,
					"refreshOn": "",
					"dataGridLabel": false,
					"showCharCount": false,
					"showWordCount": false,
					"allowMultipleMasks": false,
					"id": "edtiz6g",
					"defaultValue": null
				  }
				],
				"type": "panel",
				"breadcrumb": "default",
				"hideLabel": false,
				"tags": [],
				"conditional": {
				  "show": "",
				  "when": null,
				  "eq": ""
				},
				"properties": {},
				"placeholder": "",
				"prefix": "",
				"customClass": "",
				"suffix": "",
				"multiple": false,
				"defaultValue": null,
				"protected": false,
				"unique": false,
				"persistent": false,
				"hidden": false,
				"refreshOn": "",
				"redrawOn": "",
				"modalEdit": false,
				"label": "Panel",
				"dataGridLabel": false,
				"labelPosition": "top",
				"description": "",
				"errorLabel": "",
				"tooltip": "",
				"tabindex": "",
				"disabled": false,
				"autofocus": false,
				"dbIndex": false,
				"customDefaultValue": "",
				"calculateValue": "",
				"calculateServer": false,
				"widget": null,
				"attributes": {},
				"validateOn": "change",
				"validate": {
				  "required": false,
				  "custom": "",
				  "customPrivate": false,
				  "strictDateValidation": false,
				  "multiple": false,
				  "unique": false
				},
				"overlay": {
				  "style": "",
				  "left": "",
				  "top": "",
				  "width": "",
				  "height": ""
				},
				"allowCalculateOverride": false,
				"encrypted": false,
				"showCharCount": false,
				"showWordCount": false,
				"allowMultipleMasks": false,
				"tree": false,
				"id": "exovwja"
			  }
			],
			"width": 6,
			"offset": 0,
			"push": 0,
			"pull": 0,
			"size": "md",
			"currentWidth": 6
		  },
		//   {
		// 	"components": [
		// 	  {
		// 		"title": "Credit Card Gateway",
		// 		"theme": "default",
		// 		"tooltip": "",
		// 		"customClass": "",
		// 		"collapsible": false,
		// 		"hidden": false,
		// 		"hideLabel": false,
		// 		"disabled": false,
		// 		"modalEdit": false,
		// 		"key": "creditCardGateway",
		// 		"tags": [],
		// 		"properties": {},
		// 		"customConditional": "",
		// 		"conditional": {
		// 		  "json": "",
		// 		  "show": null,
		// 		  "when": null,
		// 		  "eq": ""
		// 		},
		// 		"logic": [],
		// 		"attributes": {},
		// 		"overlay": {
		// 		  "style": "",
		// 		  "page": "",
		// 		  "left": "",
		// 		  "top": "",
		// 		  "width": "",
		// 		  "height": ""
		// 		},
		// 		"type": "panel",
		// 		"label": "Panel",
		// 		"breadcrumb": "default",
		// 		"tabindex": "",
		// 		"input": false,
		// 		"placeholder": "",
		// 		"prefix": "",
		// 		"suffix": "",
		// 		"multiple": false,
		// 		"defaultValue": null,
		// 		"protected": false,
		// 		"unique": false,
		// 		"persistent": false,
		// 		"clearOnHide": false,
		// 		"refreshOn": "",
		// 		"redrawOn": "",
		// 		"tableView": false,
		// 		"dataGridLabel": false,
		// 		"labelPosition": "top",
		// 		"description": "",
		// 		"errorLabel": "",
		// 		"autofocus": false,
		// 		"dbIndex": false,
		// 		"customDefaultValue": "",
		// 		"calculateValue": "",
		// 		"calculateServer": false,
		// 		"widget": null,
		// 		"validateOn": "change",
		// 		"validate": {
		// 		  "required": false,
		// 		  "custom": "",
		// 		  "customPrivate": false,
		// 		  "strictDateValidation": false,
		// 		  "multiple": false,
		// 		  "unique": false
		// 		},
		// 		"allowCalculateOverride": false,
		// 		"encrypted": false,
		// 		"showCharCount": false,
		// 		"showWordCount": false,
		// 		"allowMultipleMasks": false,
		// 		"tree": false,
		// 		"components": [
		// 		  {
		// 			"label": "Gateway",
		// 			"labelPosition": "top",
		// 			"widget": "choicesjs",
		// 			"placeholder": "",
		// 			"description": "",
		// 			"tooltip": "",
		// 			"customClass": "",
		// 			"tabindex": "",
		// 			"hidden": false,
		// 			"hideLabel": false,
		// 			"uniqueOptions": false,
		// 			"autofocus": false,
		// 			"disabled": false,
		// 			"tableView": true,
		// 			"modalEdit": false,
		// 			"multiple": false,
		// 			"dataSrc": "values",
		// 			"data": {
		// 			  "values": [
		// 					{
		// 						"label": "Authorize.NET",
		// 						"value": "authorizeNet"
		// 					},
		// 					{
		// 						"label": "Bluepay",
		// 						"value": "bluepay"
		// 					},
		// 					{
		// 						"label": "Braintree",
		// 						"value": "braintree"
		// 					},
		// 					{
		// 						"label": "Cybersource",
		// 						"value": "cybersource"
		// 					},
		// 					{
		// 						"label": "Elavon",
		// 						"value": "elavon"
		// 					},
		// 					{
		// 						"label": "Hosted PCI",
		// 						"value": "hostedpci"
		// 					},
		// 					{
		// 						"label": "PayTrace",
		// 						"value": "paytrace"
		// 					},
		// 					{
		// 						"label": "Stripe",
		// 						"value": "stripe"
		// 					}
		// 				],
		// 			  "resource": "",
		// 			  "json": "",
		// 			  "url": "",
		// 			  "custom": ""
		// 			},
		// 			"dataType": "",
		// 			"idPath": "id",
		// 			"valueProperty": "",
		// 			"template": "<span>{{ item.label }}</span>",
		// 			"refreshOn": "",
		// 			"refreshOnBlur": "",
		// 			"clearOnRefresh": false,
		// 			"searchEnabled": true,
		// 			"selectThreshold": 0.3,
		// 			"readOnlyValue": false,
		// 			"customOptions": {},
		// 			"useExactSearch": false,
		// 			"persistent": true,
		// 			"protected": false,
		// 			"dbIndex": false,
		// 			"encrypted": false,
		// 			"clearOnHide": true,
		// 			"customDefaultValue": "",
		// 			"calculateValue": "",
		// 			"calculateServer": false,
		// 			"allowCalculateOverride": false,
		// 			"validateOn": "change",
		// 			"validate": {
		// 			  "required": false,
		// 			  "onlyAvailableItems": false,
		// 			  "customMessage": "",
		// 			  "custom": "",
		// 			  "customPrivate": false,
		// 			  "json": "",
		// 			  "strictDateValidation": false,
		// 			  "multiple": false,
		// 			  "unique": false
		// 			},
		// 			"unique": false,
		// 			"errorLabel": "",
		// 			"key": "VSP_Gateway",
		// 			"tags": [],
		// 			"properties": {},
		// 			"conditional": {
		// 			  "show": null,
		// 			  "when": null,
		// 			  "eq": "",
		// 			  "json": ""
		// 			},
		// 			"customConditional": "",
		// 			"logic": [],
		// 			"attributes": {},
		// 			"overlay": {
		// 			  "style": "",
		// 			  "page": "",
		// 			  "left": "",
		// 			  "top": "",
		// 			  "width": "",
		// 			  "height": ""
		// 			},
		// 			"type": "select",
		// 			"indexeddb": {
		// 			  "filter": {}
		// 			},
		// 			"selectFields": "",
		// 			"searchField": "",
		// 			"minSearch": 0,
		// 			"filter": "",
		// 			"limit": 100,
		// 			"redrawOn": "",
		// 			"input": true,
		// 			"prefix": "",
		// 			"suffix": "",
		// 			"dataGridLabel": false,
		// 			"showCharCount": false,
		// 			"showWordCount": false,
		// 			"allowMultipleMasks": false,
		// 			"lazyLoad": true,
		// 			"authenticate": false,
		// 			"ignoreCache": false,
		// 			"searchThreshold": 0.3,
		// 			"fuseOptions": {
		// 			  "include": "score",
		// 			  "threshold": 0.3
		// 			},
		// 			"id": "e6jv5b9",
		// 			"defaultValue": ""
		// 		  },
		// 		  {
		// 			"label": "Gateway URL",
		// 			"labelPosition": "top",
		// 			"placeholder": "",
		// 			"description": "",
		// 			"tooltip": "",
		// 			"prefix": "",
		// 			"suffix": "",
		// 			"widget": {
		// 			  "type": "input"
		// 			},
		// 			"inputMask": "",
		// 			"allowMultipleMasks": false,
		// 			"customClass": "",
		// 			"tabindex": "",
		// 			"autocomplete": "",
		// 			"hidden": false,
		// 			"hideLabel": false,
		// 			"showWordCount": false,
		// 			"showCharCount": false,
		// 			"mask": false,
		// 			"autofocus": false,
		// 			"spellcheck": true,
		// 			"disabled": false,
		// 			"tableView": true,
		// 			"modalEdit": false,
		// 			"multiple": false,
		// 			"persistent": true,
		// 			"inputFormat": "plain",
		// 			"protected": false,
		// 			"dbIndex": false,
		// 			"case": "",
		// 			"encrypted": false,
		// 			"redrawOn": "",
		// 			"clearOnHide": true,
		// 			"customDefaultValue": "",
		// 			"calculateValue": "",
		// 			"calculateServer": false,
		// 			"allowCalculateOverride": false,
		// 			"validateOn": "change",
		// 			"validate": {
		// 			  "required": false,
		// 			  "pattern": "",
		// 			  "customMessage": "",
		// 			  "custom": "",
		// 			  "customPrivate": false,
		// 			  "json": "",
		// 			  "minLength": "",
		// 			  "maxLength": "",
		// 			  "strictDateValidation": false,
		// 			  "multiple": false,
		// 			  "unique": false
		// 			},
		// 			"unique": false,
		// 			"errorLabel": "",
		// 			"key": "VSP_GatewayUrl",
		// 			"tags": [],
		// 			"properties": {},
		// 			"conditional": {
		// 			  "show": null,
		// 			  "when": null,
		// 			  "eq": "",
		// 			  "json": ""
		// 			},
		// 			"customConditional": "",
		// 			"logic": [],
		// 			"attributes": {},
		// 			"overlay": {
		// 			  "style": "",
		// 			  "page": "",
		// 			  "left": "",
		// 			  "top": "",
		// 			  "width": "",
		// 			  "height": ""
		// 			},
		// 			"type": "textfield",
		// 			"input": true,
		// 			"refreshOn": "",
		// 			"dataGridLabel": false,
		// 			"inputType": "text",
		// 			"id": "eqcj2wc",
		// 			"defaultValue": ""
		// 		  },
		// 		  {
		// 			"label": "Merchant ID",
		// 			"labelPosition": "top",
		// 			"placeholder": "",
		// 			"description": "",
		// 			"tooltip": "",
		// 			"prefix": "",
		// 			"suffix": "",
		// 			"widget": {
		// 			  "type": "input"
		// 			},
		// 			"inputMask": "",
		// 			"allowMultipleMasks": false,
		// 			"customClass": "",
		// 			"tabindex": "",
		// 			"autocomplete": "",
		// 			"hidden": false,
		// 			"hideLabel": false,
		// 			"showWordCount": false,
		// 			"showCharCount": false,
		// 			"mask": false,
		// 			"autofocus": false,
		// 			"spellcheck": true,
		// 			"disabled": false,
		// 			"tableView": true,
		// 			"modalEdit": false,
		// 			"multiple": false,
		// 			"persistent": true,
		// 			"inputFormat": "plain",
		// 			"protected": false,
		// 			"dbIndex": false,
		// 			"case": "",
		// 			"encrypted": false,
		// 			"redrawOn": "",
		// 			"clearOnHide": true,
		// 			"customDefaultValue": "",
		// 			"calculateValue": "",
		// 			"calculateServer": false,
		// 			"allowCalculateOverride": false,
		// 			"validateOn": "change",
		// 			"validate": {
		// 			  "required": false,
		// 			  "pattern": "",
		// 			  "customMessage": "",
		// 			  "custom": "",
		// 			  "customPrivate": false,
		// 			  "json": "",
		// 			  "minLength": "",
		// 			  "maxLength": "",
		// 			  "strictDateValidation": false,
		// 			  "multiple": false,
		// 			  "unique": false
		// 			},
		// 			"unique": false,
		// 			"errorLabel": "",
		// 			"key": "VSP_GatewayAccount",
		// 			"tags": [],
		// 			"properties": {},
		// 			"conditional": {
		// 			  "show": null,
		// 			  "when": null,
		// 			  "eq": "",
		// 			  "json": ""
		// 			},
		// 			"customConditional": "",
		// 			"logic": [],
		// 			"attributes": {},
		// 			"overlay": {
		// 			  "style": "",
		// 			  "page": "",
		// 			  "left": "",
		// 			  "top": "",
		// 			  "width": "",
		// 			  "height": ""
		// 			},
		// 			"type": "textfield",
		// 			"input": true,
		// 			"refreshOn": "",
		// 			"dataGridLabel": false,
		// 			"inputType": "text",
		// 			"id": "e7yqdf",
		// 			"defaultValue": ""
		// 		  },
		// 		  {
		// 			"label": "Gateway Key",
		// 			"labelPosition": "top",
		// 			"placeholder": "",
		// 			"description": "",
		// 			"tooltip": "",
		// 			"prefix": "",
		// 			"suffix": "",
		// 			"widget": {
		// 			  "type": "input"
		// 			},
		// 			"inputMask": "",
		// 			"allowMultipleMasks": false,
		// 			"customClass": "",
		// 			"tabindex": "",
		// 			"autocomplete": "",
		// 			"hidden": false,
		// 			"hideLabel": false,
		// 			"showWordCount": false,
		// 			"showCharCount": false,
		// 			"mask": false,
		// 			"autofocus": false,
		// 			"spellcheck": true,
		// 			"disabled": false,
		// 			"tableView": true,
		// 			"modalEdit": false,
		// 			"multiple": false,
		// 			"persistent": true,
		// 			"inputFormat": "plain",
		// 			"protected": false,
		// 			"dbIndex": false,
		// 			"case": "",
		// 			"encrypted": false,
		// 			"redrawOn": "",
		// 			"clearOnHide": true,
		// 			"customDefaultValue": "",
		// 			"calculateValue": "",
		// 			"calculateServer": false,
		// 			"allowCalculateOverride": false,
		// 			"validateOn": "change",
		// 			"validate": {
		// 			  "required": false,
		// 			  "pattern": "",
		// 			  "customMessage": "",
		// 			  "custom": "",
		// 			  "customPrivate": false,
		// 			  "json": "",
		// 			  "minLength": "",
		// 			  "maxLength": "",
		// 			  "strictDateValidation": false,
		// 			  "multiple": false,
		// 			  "unique": false
		// 			},
		// 			"unique": false,
		// 			"errorLabel": "",
		// 			"key": "VSP_GatewayKey",
		// 			"tags": [],
		// 			"properties": {},
		// 			"conditional": {
		// 			  "show": null,
		// 			  "when": null,
		// 			  "eq": "",
		// 			  "json": ""
		// 			},
		// 			"customConditional": "",
		// 			"logic": [],
		// 			"attributes": {},
		// 			"overlay": {
		// 			  "style": "",
		// 			  "page": "",
		// 			  "left": "",
		// 			  "top": "",
		// 			  "width": "",
		// 			  "height": ""
		// 			},
		// 			"type": "textfield",
		// 			"input": true,
		// 			"refreshOn": "",
		// 			"dataGridLabel": false,
		// 			"inputType": "text",
		// 			"id": "el7cvvk",
		// 			"defaultValue": ""
		// 		  },
		// 		  {
		// 			"label": "Gateway Secret",
		// 			"labelPosition": "top",
		// 			"placeholder": "",
		// 			"description": "",
		// 			"tooltip": "",
		// 			"prefix": "",
		// 			"suffix": "",
		// 			"widget": {
		// 			  "type": "input"
		// 			},
		// 			"inputMask": "",
		// 			"allowMultipleMasks": false,
		// 			"customClass": "",
		// 			"tabindex": "",
		// 			"autocomplete": "",
		// 			"hidden": false,
		// 			"hideLabel": false,
		// 			"showWordCount": false,
		// 			"showCharCount": false,
		// 			"mask": false,
		// 			"autofocus": false,
		// 			"spellcheck": true,
		// 			"disabled": false,
		// 			"tableView": true,
		// 			"modalEdit": false,
		// 			"multiple": false,
		// 			"persistent": true,
		// 			"inputFormat": "plain",
		// 			"protected": false,
		// 			"dbIndex": false,
		// 			"case": "",
		// 			"encrypted": false,
		// 			"redrawOn": "",
		// 			"clearOnHide": true,
		// 			"customDefaultValue": "",
		// 			"calculateValue": "",
		// 			"calculateServer": false,
		// 			"allowCalculateOverride": false,
		// 			"validateOn": "change",
		// 			"validate": {
		// 			  "required": false,
		// 			  "pattern": "",
		// 			  "customMessage": "",
		// 			  "custom": "",
		// 			  "customPrivate": false,
		// 			  "json": "",
		// 			  "minLength": "",
		// 			  "maxLength": "",
		// 			  "strictDateValidation": false,
		// 			  "multiple": false,
		// 			  "unique": false
		// 			},
		// 			"unique": false,
		// 			"errorLabel": "",
		// 			"key": "VSP_GatewaySecret",
		// 			"tags": [],
		// 			"properties": {},
		// 			"conditional": {
		// 			  "show": null,
		// 			  "when": null,
		// 			  "eq": "",
		// 			  "json": ""
		// 			},
		// 			"customConditional": "",
		// 			"logic": [],
		// 			"attributes": {},
		// 			"overlay": {
		// 			  "style": "",
		// 			  "page": "",
		// 			  "left": "",
		// 			  "top": "",
		// 			  "width": "",
		// 			  "height": ""
		// 			},
		// 			"type": "textfield",
		// 			"input": true,
		// 			"refreshOn": "",
		// 			"dataGridLabel": false,
		// 			"inputType": "text",
		// 			"id": "e9h6do8",
		// 			"defaultValue": ""
		// 		  }
		// 		],
		// 		"id": "ekde8mm"
		// 	  }
		// 	],
		// 	"width": 6,
		// 	"offset": 0,
		// 	"push": 0,
		// 	"pull": 0,
		// 	"size": "md",
		// 	"currentWidth": 6
		//   }
		],
		"autoAdjust": false,
		"customClass": "",
		"hidden": false,
		"hideLabel": false,
		"modalEdit": false,
		"key": "columns",
		"tags": [],
		"properties": {},
		"conditional": {
		  "show": null,
		  "when": null,
		  "eq": "",
		  "json": ""
		},
		"customConditional": "",
		"logic": [],
		"attributes": {},
		"overlay": {
		  "style": "",
		  "page": "",
		  "left": "",
		  "top": "",
		  "width": "",
		  "height": ""
		},
		"type": "columns",
		"input": false,
		"placeholder": "",
		"prefix": "",
		"suffix": "",
		"multiple": false,
		"defaultValue": null,
		"protected": false,
		"unique": false,
		"persistent": false,
		"clearOnHide": false,
		"refreshOn": "",
		"redrawOn": "",
		"tableView": false,
		"dataGridLabel": false,
		"labelPosition": "top",
		"description": "",
		"errorLabel": "",
		"tooltip": "",
		"tabindex": "",
		"disabled": false,
		"autofocus": false,
		"dbIndex": false,
		"customDefaultValue": "",
		"calculateValue": "",
		"calculateServer": false,
		"widget": null,
		"validateOn": "change",
		"validate": {
		  "required": false,
		  "custom": "",
		  "customPrivate": false,
		  "strictDateValidation": false,
		  "multiple": false,
		  "unique": false
		},
		"allowCalculateOverride": false,
		"encrypted": false,
		"showCharCount": false,
		"showWordCount": false,
		"allowMultipleMasks": false,
		"tree": false,
		"id": "ew9m0ck"
	  },
	  {
		"autofocus": false,
		"input": true,
		"label": "Submit",
		"tableView": false,
		"key": "submit",
		"size": "md",
		"leftIcon": "",
		"rightIcon": "",
		"block": false,
		"action": "submit",
		"disableOnInvalid": false,
		"theme": "primary",
		"type": "button",
		"placeholder": "",
		"prefix": "",
		"customClass": "",
		"suffix": "",
		"multiple": false,
		"defaultValue": null,
		"protected": false,
		"unique": false,
		"persistent": false,
		"hidden": false,
		"clearOnHide": true,
		"refreshOn": "",
		"redrawOn": "",
		"modalEdit": false,
		"dataGridLabel": true,
		"labelPosition": "top",
		"description": "",
		"errorLabel": "",
		"tooltip": "",
		"hideLabel": false,
		"tabindex": "",
		"disabled": false,
		"dbIndex": false,
		"customDefaultValue": "",
		"calculateValue": "",
		"calculateServer": false,
		"widget": {
		  "type": "input"
		},
		"attributes": {},
		"validateOn": "change",
		"validate": {
		  "required": false,
		  "custom": "",
		  "customPrivate": false,
		  "strictDateValidation": false,
		  "multiple": false,
		  "unique": false
		},
		"conditional": {
		  "show": null,
		  "when": null,
		  "eq": ""
		},
		"overlay": {
		  "style": "",
		  "left": "",
		  "top": "",
		  "width": "",
		  "height": ""
		},
		"allowCalculateOverride": false,
		"encrypted": false,
		"showCharCount": false,
		"showWordCount": false,
		"properties": {},
		"allowMultipleMasks": false,
		"id": "edxk2ak"
	  }
	],
	"revisions": "",
	"_vid": 0,
	"_id": "5bb62255302e6df6a766403d",
	"title": "Vendor Edit 2",
	"display": "form",
	"access": [
	  {
		"roles": [
		  "5b88072cacd5b53313ad5918",
		  "5b88072cacd5b5f747ad5919",
		  "5b88072cacd5b55293ad591a"
		],
		"type": "read_all"
	  }
	],
	"submissionAccess": [],
	"settings": {},
	"name": "vendorEdit2",
	"path": "vendoredit2",
	"project": "5b88072cacd5b53c66ad5917",
	"created": "2018-10-04T14:23:17.272Z",
	"modified": "2018-10-18T14:09:23.596Z",
	"machineName": "irlxqknnoqiregk:vendorEdit2"
  }